import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Card, Body, Spinner } from '@walmart-web/livingdesign-components';
import { useCommonOAuthRedirect } from '../../hooks/useCommonOAuthRedirect';
import { onLogOut, subHeader, updateLoading } from '../../redux/slices/globalSlice';
import style from './ChRedirect.module.scss';
import cookie from 'react-cookies';

const ChRedirect = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	useCommonOAuthRedirect({
		type: 'CP',
		status: 'REDIRECT',
		message: 'Redirecting you back to the careers site...',
		autoRedirect: true
	});
	useEffect(() => {
		dispatch(subHeader({ title: '', routeTo: '', display: false }));
		dispatch(updateLoading(false));
	}, [dispatch]);

	return (
		<div className={style.chRedirect}>
			<Card className={style.chRedirect__card}>
				<div className={style.chRedirect__content}>
					<div style={{ 
						display: 'flex', 
						flexDirection: 'column', 
						alignItems: 'center', 
						gap: '16px',
						padding: '24px' 
					}}>
						<Spinner size="medium" />
						<Body size="medium" style={{ textAlign: 'center' }}>
							{t('general.redirecting', 'Redirecting you back to the careers site...')}
						</Body>
					</div>
				</div>
			</Card>
		</div>
	);
};

export default ChRedirect;